const config = {
  NEXT_PUBLIC_BASE_URL: "https://api.dev.shreds.ai",
  //NEXT_PUBLIC_BASE_URL: "http://35.180.203.156:8080",
  //NEXT_PUBLIC_BASE_URL: "http://shreds-dev-router-alb-760112731.eu-west-3.elb.amazonaws.com",
  //NEXT_PUBLIC_BASE_URL: "http://localhost:8080",
  APP_URI: "http://localhost:3000",
};

export default config;
